// Library Methods
import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";
import { useSnackbarContext } from "src/contexts/alerts/SnackbarContext";

// Utils
import { getEMRErrorMessage } from "src/utils/emr/emrErrorHelper";

// API
import { getEMRInstaller } from "../../api";

export const useDownloadEMRInstaller = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();
  const { t } = useTranslation();
  const { setSnackbarInfo } = useSnackbarContext();

  return useMutation({
    mutationFn: async ({ hubId, alias }: { hubId: string; alias: string }) => {
      if (!clinicId) throw new Error();

      try {
        const token = await getToken();
        const { blob, fileName } = await getEMRInstaller(
          token,
          clinicId,
          hubId
        );
        return { blob, fileName: fileName ?? `EmrHub-${alias}.zip` };
      } catch (error) {
        throw error;
      }
    },
    onSuccess: ({ blob, fileName }) => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    },
    onError: (error) => {
      setSnackbarInfo({
        variant: "error",
        message: getEMRErrorMessage(
          error,
          t("EMR installer could not be downloaded!"),
          t
        ),
      });
    },
  });
};
